/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Change_No_ChoicesInputs */



/**
* | output |
* | --- |
* | "A plan change is scheduled, so no other seat type can be chosen until it has happened." |
*
* @param {Seat_Change_No_ChoicesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_no_choices = /** @type {((inputs?: Seat_Change_No_ChoicesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_No_ChoicesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Planwechsel ist geplant, daher kann bis dahin kein anderer Platztyp gewählt werden.")
	return /** @type {LocalizedString} */ ("A plan change is scheduled, so no other seat type can be chosen until it has happened.")
});